/**
 * @author        sam@zumper.com (Sam Sherman)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   GeoLocation context
 */

import React from 'react'
import type { GeoLocation } from './GeoLocation'

const GeoLocationContext = React.createContext<() => GeoLocation>(() => ({}))

export default GeoLocationContext
